import Asahi from '../data/images/karasuno/Asahi.webp';
import Daichi from '../data/images/karasuno/Daichi.webp';
import Ennoshita from '../data/images/karasuno/Ennoshita.webp';
import Kinoshita from '../data/images/karasuno/Hisashi_Kinoshita.webp';
import Narita from '../data/images/karasuno/Kazuhito_Narita.webp';
import Nishinoya from '../data/images/karasuno/Nishinoya.webp';
import Hinata from '../data/images/karasuno/Shoyo_Hinata.webp';
import Sugawara from '../data/images/karasuno/Sugawara.webp';
import Tanaka from '../data/images/karasuno/Tanaka.webp';
import Kageyama from '../data/images/karasuno/Tobio_Kageyama.webp';
import Tsukishima from '../data/images/karasuno/Tsukishima.webp';
import Yamaguchi from '../data/images/karasuno/Yamaguchi.webp';

import Fukunaga from '../data/images/nekoma/Fukunaga.webp';
import Kai from '../data/images/nekoma/Kai.webp';
import Kenma from '../data/images/nekoma/Kenma.webp';
import Kuroo from '../data/images/nekoma/Kuroo.webp';
import Lev from '../data/images/nekoma/Lev.webp';
import Shibayama from '../data/images/nekoma/Shibayama.webp';
import Inouka from '../data/images/nekoma/So_Inuoka.webp';
import Teshiro from '../data/images/nekoma/Teshiro.webp';
import Yaku from '../data/images/nekoma/Yaku.webp';
import Yamamoto from '../data/images/nekoma/Yamamoto.webp';

import Hanamaki from '../data/images/aoba_johsai/Hanamaki.webp';
import Iwaizumi from '../data/images/aoba_johsai/Iwaizumi.webp';
import Kindaichi from '../data/images/aoba_johsai/Kindaichi.webp';
import Kunimi from '../data/images/aoba_johsai/Kunimi.webp';
import Kyotani from '../data/images/aoba_johsai/Kyotani.webp';
import Matsukawa from '../data/images/aoba_johsai/matsukawa.webp';
import Oikawa from '../data/images/aoba_johsai/oikawa.webp';
import Watari from '../data/images/aoba_johsai/Watari.webp';
import Yahaba from '../data/images/aoba_johsai/Yahaba.webp';

import Aone from '../data/images/date_tech/Aone.webp';
import Futakuchi from '../data/images/date_tech/Futakuchi.webp';
import Jingo from '../data/images/date_tech/Jingo.webp';
import Moniwa from '../data/images/date_tech/Kaname_Moniwa.webp';
import Koganegawa from '../data/images/date_tech/Koganegawa.webp';
import Obara from '../data/images/date_tech/Obara.webp';
import Sakunami from '../data/images/date_tech/Sakunami.webp';
import Sasaya from '../data/images/date_tech/Takehito_Sasaya.webp';
import Onagawa from '../data/images/date_tech/Taro_Onagawa.webp';
import Kamasaki from '../data/images/date_tech/Yasushi_Kamasaki.webp';

import Akaashi from '../data/images/fukurodani/Akaashi.webp';
import Bokuto from '../data/images/fukurodani/Bokuto.webp';
import Komi from '../data/images/fukurodani/Komi.webp';
import Konoha from '../data/images/fukurodani/Konoha.webp';
import Onaga from '../data/images/fukurodani/Onaga.webp';
import Sarukui from '../data/images/fukurodani/Sarukui.webp';
import Anahori from '../data/images/fukurodani/Shuichi_anahori.webp';
import Washio from '../data/images/fukurodani/Washio.webp';

import Goshiki from '../data/images/shiratorizawa/Goshiki.webp';
import Akakura from '../data/images/shiratorizawa/Kai_Akakura.webp';
import Kawanishi from '../data/images/shiratorizawa/Kawanishi.webp';
import Reon from '../data/images/shiratorizawa/Reon.webp';
import Sagae from '../data/images/shiratorizawa/Sagae.webp';
import Semi from '../data/images/shiratorizawa/Semi.webp';
import Shirabu from '../data/images/shiratorizawa/Shirabu.webp';
import Tendo from '../data/images/shiratorizawa/Tendo.webp';
import Ushijima from '../data/images/shiratorizawa/Ushijima.webp';
import Yamagata from '../data/images/shiratorizawa/Yamagata.webp';

import Arata from '../data/images/johzenji/Arata.webp';
import Katsumichi from '../data/images/johzenji/Katsumichi.webp';
import Kazuma from '../data/images/johzenji/Kazuma.webp';
import Nobuyoshi from '../data/images/johzenji/Nobuyoshi.webp';
import Rintaro from '../data/images/johzenji/Rintaro.webp';
import Takeharu from '../data/images/johzenji/Takeharu.webp';
import Terushima from '../data/images/johzenji/Terushima.webp';

import Akagi from '../data/images/inarizaki/Akagi.webp';
import Aran from '../data/images/inarizaki/Aran.webp';
import Atsumu from '../data/images/inarizaki/Atsumu_Miya.webp';
import Ginjima from '../data/images/inarizaki/Hitoshi_Ginjima.webp';
import Kita from '../data/images/inarizaki/Kita.webp';
import Kosaku from '../data/images/inarizaki/Kosaku.webp';
import Osamu from '../data/images/inarizaki/Osamu.webp';
import Omimi from '../data/images/inarizaki/Ren_Omimi.webp';
import Riseki from '../data/images/inarizaki/Riseki.webp';
import Suna from '../data/images/inarizaki/Suna.webp';

import Chaya from '../data/images/tokonami/Chaya.webp';
import Haga from '../data/images/tokonami/Haga.webp';
import Ikejiri from '../data/images/tokonami/Ikejiri.webp';
import Komaki from '../data/images/tokonami/Komaki.webp';
import Sakurai from '../data/images/tokonami/Sakurai.webp';
import Shibuya from '../data/images/tokonami/Shibuya.webp';
import Tamagawa from '../data/images/tokonami/Tamagawa.webp';

import Nakashima from '../data/images/wakutani_minami/nakashima.webp';
import Shunki from '../data/images/wakutani_minami/Shunki.webp';
import Hanayama from '../data/images/wakutani_minami/Hanayama.webp';
import Shiroishi from '../data/images/wakutani_minami/Shiroishi.png';
import Naruko from '../data/images/wakutani_minami/Naruko.webp';
import Akiu from '../data/images/wakutani_minami/Akiu.webp';
import Matsushima from '../data/images/wakutani_minami/Matsushima.webp';

import Karamatsu from '../data/images/ohgiminami/Karamatsu.webp';
import Moritake from '../data/images/ohgiminami/Moritake.webp';
import Natsuse from '../data/images/ohgiminami/Natsuse.png';
import Oyasu from '../data/images/ohgiminami/Oyasu.webp';
import Tazawa from '../data/images/ohgiminami/Tazawa.webp';
import Towada from '../data/images/ohgiminami/Towada.webp';
import Yokote from '../data/images/ohgiminami/Yokote.webp';

import Asamushi from '../data/images/kakugawa/Asamushi.webp';
import Hyakuzawa from '../data/images/kakugawa/Hyakuzawa.webp';
import Inagaki from '../data/images/kakugawa/Inagaki.png';
import Makado from '../data/images/kakugawa/Makado.webp';
import Minamida from '../data/images/kakugawa/Minamida.png';
import Nurukawa from '../data/images/kakugawa/Nurukawa.jpg';
import Yuzuru_Komaki from '../data/images/kakugawa/Yuzuru_Komaki.webp';

import Ashiya from '../data/images/ubugawa/Ashiya.jpg';
import Gora from '../data/images/ubugawa/Gora.png';
import Isehara from '../data/images/ubugawa/Isehara.webp';
import Nakagawa from '../data/images/ubugawa/Nakagawa.png';
import Nanasawa from '../data/images/ubugawa/Nanasawa.jpg';
import Sengoku from '../data/images/ubugawa/Sengoku.jpg';
import Yukawa from '../data/images/ubugawa/Yukawa.webp';

import Akatani from '../data/images/shinzen/Akatani.webp';
import Chigaya from '../data/images/shinzen/Chigaya.png';
import Kodama from '../data/images/shinzen/Kodama.jpg';
import Naguri from '../data/images/shinzen/Naguri.png';
import Ogano from '../data/images/shinzen/Ogano.png';
import Shimafu from '../data/images/shinzen/Shimafu.png';
import Yoshikawa from '../data/images/shinzen/Yoshikawa.png';

import Akama from '../data/images/nohebi/Akama.png';
import Daisho from '../data/images/nohebi/Daisho.webp';
import Hiroo from '../data/images/nohebi/Hiroo.webp';
import Kuguri from '../data/images/nohebi/Kuguri.png';
import Numai from '../data/images/nohebi/Numai.webp';
import Sakishima from '../data/images/nohebi/Sakishima.png';
import Seguro from '../data/images/nohebi/Seguro.webp';
import Takachiho from '../data/images/nohebi/Takachiho.webp';

import Iizuna from '../data/images/itachiyama/Iizuna.jpg';
import Sakusa from '../data/images/itachiyama/Sakusa.webp';
import Komori from '../data/images/itachiyama/Komori.webp';

import Atema from '../data/images/tsubakihara/Atema.webp';
import Echigo from '../data/images/tsubakihara/Echigo.png';
import Himekawa from '../data/images/tsubakihara/Himekawa.png';
import Iwamuro from '../data/images/tsubakihara/Iwamuro.png';
import Kaikake from '../data/images/tsubakihara/Kaikake.png';
import Maiko from '../data/images/tsubakihara/Maiko.png';
import Maruyama from '../data/images/tsubakihara/Maruyama.webp';
import Mikawa from '../data/images/tsubakihara/Mikawa.png';
import Teradomari from '../data/images/tsubakihara/Teradomari.webp';
import Tsukioka from '../data/images/tsubakihara/Tsukioka.png';

import Fukatani from '../data/images/sarukawa_tech/Fukatani.png';
import Kanazawa from '../data/images/sarukawa_tech/Kanazawa.png';
import Shiga from '../data/images/sarukawa_tech/Shiga.png';
import Shiramine from '../data/images/sarukawa_tech/Shiramine.webp';
import Wajima from '../data/images/sarukawa_tech/Wajima.png';
import Wakura from '../data/images/sarukawa_tech/Wakura.webp';
import Yamashiro from '../data/images/sarukawa_tech/Yamashiro.webp';

import Bishin from '../data/images/mujinazaka/Bishin.webp';
import Ezota from '../data/images/mujinazaka/Ezota.webp';
import Hondo from '../data/images/mujinazaka/Hondo.png';
import Kiryu from '../data/images/mujinazaka/Kiryu.webp';
import Mami from '../data/images/mujinazaka/Mami.png';
import Unnan from '../data/images/mujinazaka/Unnan.webp';
import Usuri from '../data/images/mujinazaka/Usuri.webp';

import Bessho from '../data/images/komomedai/Bessho.webp';
import Hakuba from '../data/images/komomedai/Hakuba.png';
import Hirugami from '../data/images/komomedai/Hirugami.png';
import Hoshiumi from '../data/images/komomedai/Hoshiumi.png';
import Kanbayashi from '../data/images/komomedai/Kanbayashi.webp';
import Norikura from '../data/images/komomedai/Norikura.webp';
import Nozawa from '../data/images/komomedai/Nozawa.webp';
import Suwa from '../data/images/komomedai/Suwa.webp';
import Tokura from '../data/images/komomedai/Tokura.webp';

export const CharacterImageMap = {
    "Daichi Sawamura": Daichi,
    "Kōshi Sugawara": Sugawara,
    "Asahi Azumane": Asahi,
    "Yū Nishinoya": Nishinoya,
    "Ryūnosuke Tanaka": Tanaka,
    "Chikara Ennoshita": Ennoshita,
    "Hisashi Kinoshita": Kinoshita,
    "Kazuhito Narita": Narita,
    "Tobio Kageyama": Kageyama,
    "Shōyō Hinata": Hinata,
    "Kei Tsukishima": Tsukishima,
    "Tadashi Yamaguchi": Yamaguchi,
    "Tetsurō Kuroo": Kuroo,
    "Nobuyuki Kai": Kai,
    "Morisuke Yaku": Yaku,
    "Taketora Yamamoto": Yamamoto,
    "Kenma Kozume": Kenma,
    "Shōhei Fukunaga": Fukunaga,
    "Sō Inuoka": Inouka,
    "Tamahiko Teshiro": Teshiro,
    "Lev Haiba": Lev,
    "Yūki Shibayama": Shibayama,
    "Tōru Oikawa": Oikawa,
    "Issei Matsukawa": Matsukawa,
    "Takahiro Hanamaki": Hanamaki,
    "Hajime Iwaizumi": Iwaizumi,
    "Shigeru Yahaba": Yahaba,
    "Shinji Watari": Watari,
    "Yūtarō Kindaichi": Kindaichi,
    "Akira Kunimi": Kunimi,
    "Kentarō Kyōtani": Kyotani,
    "Yasushi Kamasaki": Kamasaki,
    "Kaname Moniwa": Moniwa,
    "Takehito Sasaya": Sasaya,
    "Takanobu Aone": Aone,
    "Kenji Futakuchi": Futakuchi,
    "Yutaka Obara": Obara,
    "Kanji Koganegawa": Koganegawa,
    "Tarō Onagawa": Onagawa,
    "Jingo Fukiage": Jingo,
    "Kōsuke Sakunami": Sakunami,
    "Tatsuki Washio": Washio,
    "Yamato Sarukui": Sarukui,
    "Kōtarō Bokuto": Bokuto,
    "Keiji Akaashi": Akaashi,
    "Akinori Konoha": Konoha,
    "Shūichi Anahori": Anahori,
    "Haruki Komi": Komi,
    "Wataru Onaga": Onaga,
    "Wakatoshi Ushijima": Ushijima,
    "Eita Semi": Semi,
    "Reon Ōhira": Reon,
    "Satori Tendō": Tendo,
    "Tsutomu Goshiki": Goshiki,
    "Kenjirō Shirabu": Shirabu,
    "Taichi Kawanishi": Kawanishi,
    "Kai Akakura": Akakura,
    "Hayato Yamagata": Yamagata,
    "Yūshō Sagae": Sagae,
    "Yūji Terushima": Terushima,
    "Kazuma Bobata": Kazuma,
    "Takeharu Futamata": Takeharu,
    "Katsumichi Higashiyama": Katsumichi,
    "Rintarō Numajiri": Rintaro,
    "Nobuyoshi Īzaka": Nobuyoshi,
    "Arata Tsuchiyu": Arata,
    "Shinsuke Kita": Kita,
    "Ren Ōmimi": Omimi,
    "Aran Ojiro": Aran,
    "Hitoshi Ginjima": Ginjima,
    "Atsumu Miya": Atsumu,
    "Rintarō Suna": Suna,
    "Osamu Miya": Osamu,
    "Yūto Kosaku": Kosaku,
    "Heisuke Riseki": Riseki,
    "Michinari Akagi": Akagi,
    "Hikaru Komaki": Komaki,
    "Kazuma Chaya": Chaya,
    "Hayato Ikejiri": Ikejiri,
    "Hiroki Tamagawa": Tamagawa,
    "Yoshiharu Haga": Haga,
    "Rikuto Shibuya": Shibuya,
    "Taiga Sakurai": Sakurai,
    "Takeru Nakashima": Nakashima,
    "Shunki Kawatabi": Shunki,
    "Kazumasa Hanayama": Hanayama,
    "Yūki Shiroishi": Shiroishi,
    "Teppei Naruko": Naruko,
    "Kazuteru Akiu": Akiu,
    "Tsuyoshi Matsushima": Matsushima,
    "Yoshiki Towada": Towada,
    "Takumi Karamatsu": Karamatsu,
    "Yūki Tazawa": Tazawa,
    "Ayumu Moritake": Moritake,
    "Sōma Oyasu": Oyasu,
    "Ibuki Natsuse": Natsuse,
    "Shun Yokote": Yokote,
    "Yoshiaki Nurukawa": Nurukawa,
    "Eiji Makado": Makado,
    "Kaito Asamushi": Asamushi,
    "Yuzuru Komaki": Yuzuru_Komaki,
    "Isao Inagaki": Inagaki,
    "Yūdai Hyakuzawa": Hyakuzawa,
    "Taishi Minamida": Minamida,
    "Masaki Gōra": Gora,
    "Yōhei Ashiya": Ashiya,
    "Kengo Nanasawa": Nanasawa,
    "Shingo Sengoku": Sengoku,
    "Yūji Isehara": Isehara,
    "Kōji Yukawa": Yukawa,
    "Toshimi Nakagawa": Nakagawa,
    "Daiki Ogano": Ogano,
    "Shōta Naguri": Naguri,
    "Noriaki Shimafu": Shimafu,
    "Eikichi Chigaya": Chigaya,
    "Masaru Kodama": Kodama,
    "Yū Akatani": Akatani,
    "Kazutaka Yoshikawa": Yoshikawa,
    "Suguru Daishō": Daisho,
    "Yoshiya Takachiho": Takachiho,
    "Kazuma Numai": Numai,
    "Kōji Hiroo": Hiroo,
    "Isumi Sakishima": Sakishima,
    "Sō Akama": Akama,
    "Akihiko Seguro": Seguro,
    "Naoyasu Kuguri": Kuguri,
    "Tsukasa Iizuna": Iizuna,
    "Kiyoomi Sakusa": Sakusa,
    "Motoya Komori": Komori,
    "Kazuki Maruyama": Maruyama,
    "Sakae Echigo": Echigo,
    "Chiharu Tsukioka": Tsukioka,
    "Motoki Teradomari": Teradomari,
    "Dai Mikawa": Mikawa,
    "Tōgo Iwamuro": Iwamuro,
    "Yoshitomo Atema": Atema,
    "Yūshi Maiko": Maiko,
    "Akifumi Kaikake": Kaikake,
    "Aoi Himekawa": Himekawa,
    "Itaru Shiramine": Shiramine,
    "Hisahiko Wakura": Wakura,
    "Iori Kanazawa": Kanazawa,
    "Tomonari Shiga": Shiga,
    "Tomokazu Wajima": Wajima,
    "Kenrō Fukatani": Fukatani,
    "Sōji Yamashiro": Yamashiro,
    "Wakatsu Kiryū": Kiryu,
    "Nozomu Mami": Mami,
    "Keisuke Unnan": Unnan,
    "Naoharu Ezota": Ezota,
    "Michiru Usuri": Usuri,
    "Subaru Hondo": Hondo,
    "Haruma Bishin": Bishin,
    "Aikichi Suwa": Suwa,
    "Izuru Nozawa": Nozawa,
    "Kōrai Hoshiumi": Hoshiumi,
    "Sachirō Hirugami": Hirugami,
    "Isao Norikura": Norikura,
    "Kazuyoshi Bessho": Bessho,
    "Gao Hakuba": Hakuba,
    "Liam Tokura": Tokura,
    "Keiichirō Kanbayashi": Kanbayashi
};